import ArchiveGoalPrompt from "./Common/ArchiveGoalPrompt.en";
import ActivityCommentForm from "./Common/ActivityCommentForm.en";
import DeleteGoalPrompt from "./Common/DeleteGoalPrompt.en";
import DeleteKeyResultPrompt from "./Common/DeleteKeyResultPrompt.en";
import DiscardChangesPrompt from "./Common/DiscardChangesPrompt.en";
import GoalActivityPanel from "./Goal/GoalActivityPanel.en";
import GoalArchiveActivity from "./Goal/GoalArchiveActivity.en";
import GoalCard from "./Goals/GoalCard.en";
import GoalCommentActivity from "./Goal/GoalCommentActivity.en";
import GoalConfidenceActivity from "./Goal/GoalConfidenceActivity.en";
import GoalCountChip from "./Goals/GoalCountChip.en";
import GoalCreationActivity from "./Goal/GoalCreationActivity.en";
import GoalDueDateActivity from "./Goal/GoalDueDateActivity.en";
import GoalFinishDateActivity from "./Goal/GoalFinishDateActivity.en";
import GoalForm from "./Common/GoalForm.en";
import GoalKRCommentActivity from "./Goal/GoalKRCommentActivity.en";
import GoalKRConfidenceActivity from "./Goal/GoalKRConfidenceActivity.en";
import GoalKRCreationActivity from "./Goal/GoalKRCreationActivity.en";
import GoalKRNameActivity from "./Goal/GoalKRNameActivity.en";
import GoalKROwnerActivity from "./Goal/GoalKROwnerActivity.en";
import GoalKRProgressActivity from "./Goal/GoalKRProgressActivity.en";
import GoalKRSortOrderActivity from "./Goal/GoalKRSortOrderActivity.en";
import GoalKRTypeActivity from "./Goal/GoalKRTypeActivity.en";
import GoalStartDateActivity from "./Goal/GoalStartDateActivity.en";
import GoalSubHeader from "./Goal/GoalSubHeader.en";
import GoalSubHeaderSkeleton from "./Goal/GoalSubHeaderSkeleton.en";
import GoalTabSet from "./Goal/GoalTabSet.en";
import GoalTeamActivity from "./Goal/GoalTeamActivity.en";
import GoalTitleActivity from "./Goal/GoalTitleActivity.en";
import KRActivityPanel from "./KeyResult/KRActivityPanel.en";
import KRCommentActivity from "./KeyResult/KRCommentActivity.en";
import KRConfidenceActivity from "./KeyResult/KRConfidenceActivity.en";
import KRCreationActivity from "./KeyResult/KRCreationActivity.en";
import KRNameActivity from "./KeyResult/KRNameActivity.en";
import KROwnerActivity from "./KeyResult/KROwnerActivity.en";
import KRPanel from "./Goal/KRPanel.en";
import KRPlacard from "./Goal/KRPlacard.en";
import KRProgressActivity from "./KeyResult/KRProgressActivity.en";
import KRSortOrderActivity from "./KeyResult/KRSortOrderActivity.en";
import KRSubHeader from "./KeyResult/KRSubHeader.en";
import KRSubHeaderSkeleton from "./KeyResult/KRSubHeaderSkeleton.en";
import KRTabSet from "./KeyResult/KRTabSet.en";
import KRTypeActivity from "./KeyResult/KRTypeActivity.en";
import KeyResultForm from "./Common/KeyResultForm.en";
import MyGoalsPageHeader from "./Goals/GoalsPageHeader.en";
import NewGoalActivityPanel from "./NewGoal/NewGoalActivityPanel.en";
import NewGoalHeader from "./NewGoal/NewGoalHeader.en";
import NewGoalKRPanel from "./NewGoal/NewGoalKRPanel.en";
import NewKeyResultForm from "./NewGoal/NewKeyResultForm.en";
import NewKeyResultHeader from "./NewKeyResult/NewKeyResultHeader.en";
import NoGoalsPlaceholder from "./Goals/NoGoalsPlaceholder.en";
import NoKRsPlaceholder from "./Goal/NoKRsPlaceholder.en";
import UnarchiveGoalPrompt from "./Common/UnarchiveGoalPrompt.en";
import UnknownActivity from "./Activity/UnknownActivity.en";

export default {
	ArchiveGoalPrompt,
	ActivityCommentForm,
	DeleteGoalPrompt,
	DeleteKeyResultPrompt,
	DiscardChangesPrompt,
	GoalActivityPanel,
	GoalArchiveActivity,
	GoalCard,
	GoalCommentActivity,
	GoalConfidenceActivity,
	GoalCountChip,
	GoalCreationActivity,
	GoalDueDateActivity,
	GoalFinishDateActivity,
	GoalForm,
	GoalKRCommentActivity,
	GoalKRConfidenceActivity,
	GoalKRCreationActivity,
	GoalKRNameActivity,
	GoalKROwnerActivity,
	GoalKRProgressActivity,
	GoalKRSortOrderActivity,
	GoalKRTypeActivity,
	GoalStartDateActivity,
	GoalSubHeader,
	GoalSubHeaderSkeleton,
	GoalTabSet,
	GoalTeamActivity,
	GoalTitleActivity,
	KRActivityPanel,
	KRCommentActivity,
	KRConfidenceActivity,
	KRCreationActivity,
	KRNameActivity,
	KROwnerActivity,
	KRPanel,
	KRPlacard,
	KRProgressActivity,
	KRSortOrderActivity,
	KRSubHeader,
	KRSubHeaderSkeleton,
	KRTabSet,
	KRTypeActivity,
	KeyResultForm,
	MyGoalsPageHeader,
	NewGoalActivityPanel,
	NewGoalHeader,
	NewGoalKRPanel,
	NewKeyResultForm,
	NewKeyResultHeader,
	NoGoalsPlaceholder,
	NoKRsPlaceholder,
	UnarchiveGoalPrompt,
	UnknownActivity,
};
